/// <amd-module name="Build/Admin/Tabs/AccountPoolsTab" />
import * as React from "react";

import { Components, VssComponent, IVssComponentProperties, IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";

import { NavigationActionCreator } from "Build/Admin/Common/Actions/NavigationActionCreator";

export interface IAccountPoolsTabState {
    poolId: number | undefined;
    agentId: number | undefined;
}

class AccountPoolsTab extends VssComponent<IVssComponentProperties, IAccountPoolsTabState> {
    private _navigationActionCreator: NavigationActionCreator;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this._navigationActionCreator = new NavigationActionCreator({ pageContext: context.pageContext });
        this.state = this._getState();
    }

    public render(): JSX.Element {
        if (this.state.poolId && this.state.agentId) {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.agent"]}
                wrappedType={"ms.vss-build-web.admin-agent-view-component"}
            />;
        }
        else if (this.state.poolId) {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.pool"]}
                wrappedType={"ms.vss-build-web.admin-pool-view-component"}
            />;
        }
        else {
            return <WrappedComponent
                dependencies={["ms.vss-build-web.admin.poolslist"]}
                wrappedType={"ms.vss-build-web.admin-pools-list-view-component"}
            />;
        }
    }

    private _getState(): IAccountPoolsTabState {
        return {
            poolId: this._navigationActionCreator.getPoolIdParam(),
            agentId: this._navigationActionCreator.getAgentIdParam()
        };
    }
}

Components.add("build-admin-account-pools-tab", AccountPoolsTab);
